import { render, staticRenderFns } from "./Certificacao.vue?vue&type=template&id=4a02645a"
import script from "./Certificacao.vue?vue&type=script&lang=js"
export * from "./Certificacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports